module.exports = __webpack_public_path__ + "img/invoice.a07e4c7f.jpg";